import React, { useState } from "react";
import { Grid, InputAdornment, IconButton, Typography } from "@mui/material";
import ThemeColor from "../../theme/ThemeColor";
import { H5FormLabel, H1FormTitle } from "../../theme/Theme";
import { CustemButton, InputBox } from "../../components/Custom";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {LoginContainer, LogoBox, ForgotPasswordDetails} from './Authorization.style'
import Swal from "sweetalert2";
import { EyeCloseIcon, EyeOpenIcon } from "../../components/Icons";
import  validate  from "../../validation/validation";
import DisplayError from "../../validation/DisplayError";
import image from "../../asserts/LALogistic-1.png"
import SignInImage from "../../asserts/LoginImage.jpg";

const ChangePassword = () => {
  const location = useLocation();
  const email = location?.state?.prevData.email;
  const oldPassword = location?.state?.prevData.password;
  const [error, setError] = useState([])
  const [reqData, setReqData] = useState({
    email: email,
    oldPassword: oldPassword,
    newPassword: "",
    retypePassword: "",
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [showPassword, setShowPassword] = useState(true);

  function checkEmail(event, key) {
    setReqData({ ...reqData, [key]: event.target.value?.trim() });
  }

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleClickSubmit();
    }
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  let validation_input = [
    {tagid: 'password', text: reqData.newPassword, required: true, regex_name: 'password', errmsg: 'Please enter valid password.'},
  ]

  // submit the login details
  const handleClickSubmit = () => {
    // if (reqData.newPassword == "" || reqData.retypePassword == "") {
    //   return Swal.fire({
    //     title: "Enter Password Or Confirm Password",
    //     icon: "warning",
    //   });
    // }
    if(validate(validation_input).length == 0){
      setLoader(true);
      if(reqData.newPassword === reqData.retypePassword){
        // dispatch(UpdateUserPass(reqData)).then((res) => {
        //   if (res?.payload) {
        //     const userDetails = location.state.res?.payload?.userDetails;
        //     const updatedUserDetails = { userId:userDetails.userId, Isuserexist: true };
        //     dispatch(UpdateUserDetails(updatedUserDetails)).then((resp)=>{
        //       localStorage.setItem("accesstoken", location.state.res?.payload?.accessToken)
        //       localStorage.setItem("refreshtoken", location.state.res?.payload?.refreshToken)
        //       localStorage.setItem("userdetails", JSON.stringify(location.state.res?.payload?.userDetails))
        //       localStorage.setItem("role", location.state.res?.payload?.userDetails?.role?.roleName)
        //       setHeaders('x-access-token', location.state.res?.payload?.accessToken); 
        //       setLoader(false);
        //       navigate('/dashboard')
        //       window.location.reload();
        //     })
        //   } else {
        //     setLoader(false);
        //     Swal.fire({
        //       title: "Invalid Credentials",
        //       icon: "error",
        //     });
        //   }
        // });
      }else{
        setError([])
        setLoader(false)
        Swal.fire({ title: "The Retype password does not match", icon: "error"});
      }   
    }else{
      setError(validate(validation_input))
    }  
  };


  return (
    <>
      <Grid container>
        <Grid size={{ xs: 12, sm: 10, md: 10, lg:8 }} style={{display:'flex', justifyContent:"center"}}>
          <img src={SignInImage} alt="Login" style={{ width: 'auto', height: '100vh', objectFit: 'cover'}} />
        </Grid>

        {/* Employee Forget Password Details */}
        <Grid size={{ xs: 12, sm: 10, md: 10, lg:4 }} style={{background:'#F1F1F1', borderBottomRightRadius:'10px', borderTopRightRadius:'10px', height:'auto', maxWidth:'100%'}}>
          <LogoBox>
            <img src={image} width={172} height={130} alt="" style={{objectFit: 'cover'}}/>
          </LogoBox>
        </Grid>
        
          <ForgotPasswordDetails>
            <H1FormTitle sx={{color:ThemeColor.palette.BrandColor, mt:1}}>
              Change Password 
            </H1FormTitle>
          {/* Display form */}
          <Grid size={{ xs: 12, sm: 6, md: 4, lg:8}}>
            <H5FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>Enter New Password </H5FormLabel>
            <InputBox
              name="password"
              type={showPassword ? "password" : "text"}
              onChange={(event) => checkEmail(event, "newPassword")}
              sx={{
                borderRadius: "10px",
                height: "50px",
                border: "2px solid rgba(0, 0, 0, 0.3)",
                fontSize: "14px",
                width: "100%",
                p: 0.1,
                pl: 2,
              }}
              placeholder="8 + Characters 1 Capital letter"
              onPaste={(e) => e.preventDefault()}
              onCopy={(e) => e.preventDefault()}
              onKeyPress={handleKeyPress}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    style={{ ml: 1 }}
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                  >
                    {showPassword ? <EyeCloseIcon /> : <EyeOpenIcon />}
                  </IconButton>
                </InputAdornment>
              }
            />
            <DisplayError error={error} fortagid='password'/>
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 4, lg:8}}>
            <H5FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>Retype Password</H5FormLabel>
            <InputBox
              name="password"
              type={showPassword ? "password" : "text"}
              onChange={(event) => checkEmail(event, "retypePassword")}
              sx={{
                borderRadius: "10px",
                height: "50px",
                border: "2px solid rgba(0, 0, 0, 0.3)",
                fontSize: "14px",
                width: "100%",
                p: 0.1,
                pl: 2,
              }}
              placeholder="8 + Characters 1 Capital letter"
              onPaste={(e) => e.preventDefault()}
              onCopy={(e) => e.preventDefault()}
              onKeyPress={handleKeyPress}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    style={{ ml: 1 }}
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                  >
                    {showPassword ? <EyeCloseIcon /> : <EyeOpenIcon />}
                  </IconButton>
                </InputAdornment>
              }
            />
            <DisplayError error={error} fortagid='password'/>
          </Grid>
          <Typography sx={{color:'#000000', fontSize:'10px', letterSpacing:0.5}}>(Password must be 8 characters long with 1 uppercase letter, number & special character.)</Typography>
        </ForgotPasswordDetails>

        <Grid
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            marginTop: "40px",
          }}
        >
          <CustemButton
            variant="contained"
            id="Submit"
            text="Submit"
            onClick={handleClickSubmit}
            backgroundColor={ThemeColor.palette.ButtonColor}
            sx={{
              borderRadius: "10px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
              fontSize: "16px",
              letterSpacing: "1px",
              pl: 7,
              pr: 7,
              pt: 1.5,
              pb: 1.5,
              fontWeight: 600,
            }}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default ChangePassword;
